// extracted by mini-css-extract-plugin
export var productImage = "_n5-1";
export var viewLink = "_n5-2";
export var wishlistItem = "_n5-0";